export default __webpack_public_path__ + "static/media/triangle1.9ed1bf17.svg";